import { ReactElement } from 'react'
import { PricingRule } from '../../../../GlobalJobMatchingVersioning/types/rules'
import { MarketElementResponse } from '../../../../../../hooks/global-job-matching'
import { DynamicColumns } from '../../../../../../lib/types/AppState/Session.interface'

export type ColumnDef = {
  label: string,
  fieldCode: string
  w?: number | string
  maw?: number | string
  disableSort?: boolean
  disableFilter?: boolean
  type: 'text' | 'number'
  isMonetary?: boolean
  customRender?: (row: Record<string, any>, col: Record<string, any>) => ReactElement
}

export const genColumnsDef = (rules: PricingRule, marketElements: MarketElementResponse | undefined, dynamicColumns: DynamicColumns): ColumnDef[] => {
const defaultMarketElementsColumnsDef: ColumnDef[] = [
  { label: 'Base Salary 50th', fieldCode: 'base_salary_50th', type: 'number', isMonetary: true },
]

const selectedMarketElementsColumnsDef: ColumnDef[] = []
  rules.marketDataElements?.forEach(mde => {
    const foundElement = marketElements?.payElements?.find(pe => pe.source_field === mde)
    if (!foundElement) return
    selectedMarketElementsColumnsDef.push({
      label: foundElement.field_title,
      fieldCode: foundElement.source_field,
      type: 'number',
      isMonetary: true
  })
})

const marketElementsDisplay = rules.marketDataElements?.length ? selectedMarketElementsColumnsDef : defaultMarketElementsColumnsDef

return [
    { label: dynamicColumns.job_org_unit_text ?? 'Job Family', fieldCode: 'org_unit', w: 120, type: 'text' },
    { label: 'Job Title', fieldCode: 'org_job_title', maw: 400, type: 'text' },
    { label: 'Job Code', fieldCode: 'org_job_code', maw: 275, type: 'text' },
    { label: dynamicColumns.job_code_key_text ?? 'Job Code Key', fieldCode: 'org_job_code_key', w: 120, type: 'text' },
    { label: 'Survey Code', fieldCode: 'survey_code', type: 'text' },
    { label: 'Survey Job Code', fieldCode: 'survey_job_code', type: 'text' },
    { label: 'Data Cut', fieldCode: 'job_scope', type: 'text', maw: 300 },
    ...marketElementsDisplay,
    { label: 'Benchmark Year', fieldCode: 'survey_year', w: 100, type: 'number' },
  ]
}
